import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

export interface MaximumResidentUsers {
  maximumResidentUsers: number;
}

@Component({
  selector: 'ml-maximum-resident-users-ui',
  templateUrl: 'maximum-resident-users.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule],
})
export class ManagedSettingsMaximumResidentUsersComponent {
  private readonly fb = inject(UntypedFormBuilder);
  private cd = inject(ChangeDetectorRef);

  readonly maximumResidentUsers = output<MaximumResidentUsers>();

  public readonly maximumResidentUsersForm = this.fb.group({
    maximumResidentUsers: '',
  });

  onSubmit() {
    this.maximumResidentUsers.emit(this.maximumResidentUsersForm.value);
  }
}
